<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
    >
      <template v-slot:showItem="{ row }">
        <el-row :gutter="10">
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              开始日期：
              {{ row.startDate }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              结束日期：
              {{ row.endDate }}
            </span>
          </el-col>

          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              费用项目：
              {{ row.v_expenseType }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              明细费用：
              {{ row.expenseName }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              原始费用项目：
              {{ row.v_originalExpenseType }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              单据张数：
              {{ row.billCount }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              费用金额：
              {{ row.currencyAmount }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              费用客户：
              {{ row.custName }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              相关订单：
              {{ row.custOrderNo }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              品牌：
              {{ row.brandName }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 5 }"
          >
            <span>
              供应商：
              {{ row.scmName }}
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 12 }"
            :md="{ span: 12 }"
            :lg="{ span: 9 }"
          >
            <span>
              分摊部门：
              {{ row.orgDepFullName }}
            </span>
          </el-col>
        </el-row>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
}
</script>
